var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count > 0 || _vm.forceShow)?_c('span',{class:("chip chip-" + _vm.type)},[_c('strong',{staticClass:"me-2"},[_vm._v(_vm._s(_vm.count))]),_c('p',[_vm._v(_vm._s(_vm.suffix))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }